import Link from '@components/Link';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';

import { MenuAddonLink } from './GetHelpText.module.css';

const GetHelpText = () => {
  const { t } = useTranslation(['account', 'common', 'checkout']);
  const { options } = useSelector((state) => state.wordpress) || {};

  return (
    <>
      {t('gotProblems', { ns: 'common' })}?{' '}
      <Link
        target="_blank"
        className={MenuAddonLink}
        href={options?.faqHelpPage?.link || '/'}
      >
        {t('getHelp', { ns: 'common' })}
      </Link>
    </>
  );
};

export default GetHelpText;
